<template>
  <v-layout ml-4 child-flex>
    <div class="page-title">{{ title }}</div>
  </v-layout>
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.page-title {
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 2rem;
  margin-top: 16px;
}
</style>
